import { observable, makeObservable, action } from "mobx";
import { IStatusAndAlert, IClientStatus } from "./types";

export interface ClientDetails {
    clientName: string;
    locationName: string;
    areaName: string;

    timestamp: string;
    residentProfileIntervalDayStartTime: string;
    residentProfileIntervalNightStartTime: string;
}

export enum StoryStatusTypes {
    OutOfRoom,
    InBathroom,
    InRoom,
    InBed,
    OutOfBed,
}

export class ClientDashboardStore {
    constructor() {
        makeObservable(this, {
            clientDetails: observable,
            statusesAndAlerts: observable,
            clientStatuses: observable,
            isDataLoading: observable,
            isTranslationLoading: observable,
            historicalTab: observable,
            periodStatistics: observable,

            setStatusesAndAlers: action,
            setIsTranslationLoading: action,
            clearPeriodStatistics: action,
        });
    }

    public clientDetails: ClientDetails = {
        clientName: "",
        locationName: "",
        areaName: "",
        residentProfileIntervalDayStartTime: "",
        residentProfileIntervalNightStartTime: "",

        timestamp: "",
    };

    public isTranslationLoading: boolean = false;
    public isDataLoading: boolean = false;
    public statusesAndAlerts: IStatusAndAlert[] = [];
    public clientStatuses: IClientStatus[] = [];
    public historicalTab: number = 0;

    public periodStatistics = {
        daily: {
            hours: {
                OutOfRoom: 0,
                InBathroom: 0,
                InRoom: 0,
                InBed: 0,
                OutOfBed: 0,
                Other: 0,
            },
            count: {
                OutOfRoom: 0,
                InBathroom: 0,
                InRoom: 0,
                InBed: 0,
                OutOfBed: 0,
                Other: 0,
            },
        },
        sevenDays: {
            hours: {
                OutOfRoom: 0,
                InBathroom: 0,
                InRoom: 0,
                InBed: 0,
                OutOfBed: 0,
                Other: 0,
            },
            count: {
                OutOfRoom: 0,
                InBathroom: 0,
                InRoom: 0,
                InBed: 0,
                OutOfBed: 0,
                Other: 0,
            },
        },
        thirtyDays: {
            hours: {
                OutOfRoom: 0,
                InBathroom: 0,
                InRoom: 0,
                InBed: 0,
                OutOfBed: 0,
                Other: 0,
            },
            count: {
                OutOfRoom: 0,
                InBathroom: 0,
                InRoom: 0,
                InBed: 0,
                OutOfBed: 0,
                Other: 0,
            },
        },
    };

    public lastValidTimestamp: string = "";

    public setHistoricalTab(value: number) {
        this.historicalTab = value;
    }

    public setStatusesAndAlers(value: IStatusAndAlert[]) {
        this.statusesAndAlerts = value;
    }

    public setIsTranslationLoading(value: boolean) {
        this.isTranslationLoading = value;
    }

    public clearPeriodStatistics() {
        this.periodStatistics = {
            daily: {
                hours: {
                    OutOfRoom: 0,
                    InBathroom: 0,
                    InRoom: 0,
                    InBed: 0,
                    OutOfBed: 0,
                    Other: 0,
                },
                count: {
                    OutOfRoom: 0,
                    InBathroom: 0,
                    InRoom: 0,
                    InBed: 0,
                    OutOfBed: 0,
                    Other: 0,
                },
            },
            sevenDays: {
                hours: {
                    OutOfRoom: 0,
                    InBathroom: 0,
                    InRoom: 0,
                    InBed: 0,
                    OutOfBed: 0,
                    Other: 0,
                },
                count: {
                    OutOfRoom: 0,
                    InBathroom: 0,
                    InRoom: 0,
                    InBed: 0,
                    OutOfBed: 0,
                    Other: 0,
                },
            },
            thirtyDays: {
                hours: {
                    OutOfRoom: 0,
                    InBathroom: 0,
                    InRoom: 0,
                    InBed: 0,
                    OutOfBed: 0,
                    Other: 0,
                },
                count: {
                    OutOfRoom: 0,
                    InBathroom: 0,
                    InRoom: 0,
                    InBed: 0,
                    OutOfBed: 0,
                    Other: 0,
                },
            },
        };
    }
}
